// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".s-module__wrap--Zm5Qt {\n  padding: 16px 20px;\n}\n", "",{"version":3,"sources":["webpack://./src/pages/dashboard/InboxPage/MessageContainer/components/InboxMessageList/s.module.less"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ","sourcesContent":[".wrap {\n    padding: 16px 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": "s-module__wrap--Zm5Qt"
};
export default ___CSS_LOADER_EXPORT___;
